import PandaQuestion1 from "../../assets/images/Panda/PandaQuestion1.png";
import SectionBannerContact from "../../components/main/SectionBannerContact";
import SectionContactInfo from "../../components/main/SectionContactInfo";
import SectionForm from "../../components/main/SectionForm";
import SectionQuestion from "../../components/main/SectionQuestion";
import SEOHead from "../../components/common/SEOHead";
import JsonLd from "../../components/common/JsonLd";

const Contact: React.FC = () => {
  const faqs = [
    {
      key: "1",
      q: "Quy trình tiếp nhận và tư vấn giải pháp tại TrioCore Solutions diễn ra như thế nào?",
      a: "Sau khi nhận thông tin liên hệ, chuyên viên chuyên trách theo từng mảng (Tech hoặc Marketing) sẽ gọi điện trao đổi sâu hơn về bài toán của bạn. Chúng tôi sẽ tiến hành khảo sát, xây dựng chiến lược sơ bộ và gửi báo giá chi tiết trong vòng 24h - 48h làm việc.",
    },
    {
      key: "2",
      q: "Chi phí tư vấn giải pháp ban đầu là bao nhiêu?",
      a: "Toàn bộ quá trình khảo sát bài toán kinh doanh, tư vấn định hướng công nghệ và lên kế hoạch marketing sơ bộ ban đầu tại TrioCore Solutions là hoàn toàn miễn phí. Bạn chỉ trả chi phí khi hai bên chính thức ký hợp đồng triển khai hạng mục.",
    },
    {
      key: "3",
      q: "Công ty tôi ở tỉnh khác (ngoài TP.HCM) thì TrioCore Solutions hỗ trợ làm việc và bàn giao thế nào?",
      a: "TrioCore Solutions hỗ trợ làm việc và triển khai online toàn quốc. Toàn bộ tiến độ công việc, tài liệu kỹ thuật, mã nguồn hoặc số liệu chiến dịch marketing đều được quản lý trực quan trên các công cụ số để bạn dễ dàng giám sát từ xa.",
    },
    {
      key: "4",
      q: "Hệ thống sau khi bàn giao nếu gặp sự cố thì liên hệ qua đầu mối nào?",
      a: "Bạn có thể liên hệ trực tiếp qua Hotline kỹ thuật 0822 041 909 hoặc tạo yêu cầu hỗ trợ qua Zalo/Email. Đội ngũ kỹ sư trực hệ thống của chúng tôi cam kết tiếp nhận và xử lý các sự cố kỹ thuật trong thời gian sớm nhất để không ảnh hưởng đến vận hành của doanh nghiệp.",
    },
    {
      key: "5",
      q: "Thông tin doanh nghiệp gửi qua form liên hệ có được bảo mật không?",
      a: "Có. TrioCore Solutions chỉ sử dụng thông tin bạn cung cấp cho mục đích tiếp nhận yêu cầu, phân tích bài toán và tư vấn giải pháp phù hợp. Chúng tôi không chia sẻ dữ liệu này cho bên thứ ba nếu chưa có sự đồng ý từ phía doanh nghiệp.",
    },
    {
      key: "6",
      q: "Trước buổi trao đổi với TrioCore Solutions, doanh nghiệp cần chuẩn bị những gì?",
      a: "Bạn chỉ cần chuẩn bị ngắn gọn về mục tiêu kinh doanh, các vấn đề đang gặp phải, hệ thống hiện có và kỳ vọng triển khai. Nếu đã có tài liệu mô tả quy trình, website hiện tại hoặc dữ liệu chiến dịch cũ thì việc tư vấn sẽ càng nhanh và chính xác hơn.",
    },
    {
      key: "7",
      q: "Ngoài giờ hành chính, TrioCore Solutions có tiếp nhận yêu cầu khẩn không?",
      a: "Có. Với các nhu cầu khẩn liên quan đến hệ thống đang vận hành, doanh nghiệp vẫn có thể liên hệ qua hotline hoặc để lại yêu cầu qua email. Chúng tôi sẽ ưu tiên tiếp nhận sớm nhất có thể và sắp xếp đầu mối phù hợp để hỗ trợ kịp thời.",
    },
  ];

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Trang chủ",
        "item": "https://triocoresolutions.com.vn/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Liên hệ",
        "item": "https://triocoresolutions.com.vn/contact"
      }
    ]
  };

  return (
    <>
      <SEOHead title="Liên Hệ — TrioCore Solutions" description="Liên hệ ngay với TrioCore Solutions để được tư vấn miễn phí giải pháp phát triển website, app mobile và các chiến dịch digital marketing hiệu quả nhất." path="/contact" />
      <JsonLd data={breadcrumbData} />
      <SectionBannerContact />
      <SectionContactInfo />
      <SectionForm />
      <SectionQuestion
        title="Câu hỏi thường gặp về liên hệ và tư vấn giải pháp"
        faqs={faqs}
        img={
          <img
            className="absolute -top-4 left-5 w-[380px] object-cover lg:-top-6"
            src={PandaQuestion1}
            alt="Panda Mascot"
            width="380"
            height="380"
            loading="lazy"
          />
        }
      />
    </>
  );
};

export default Contact;
